<template>
  <div>
    <v-card-title class="ma-0 pa-0">
      <v-spacer></v-spacer>
      <v-btn color="success" outlined @click="cadastrarAtividadePosVenda()" v-if="getPosVenda.status != 'FINALIZADO'"
        >Registrar Atividade</v-btn
      >

    </v-card-title>

    
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Data/Hora</th>
            <th>Funcionário</th>
            <th>Descrição</th>
            <!-- <th align="center">Concluída</th> -->
            <th></th>
          </tr>
        </thead>
        <tbody v-if="getAtividadesPosVenda.length > 0">
          <tr v-for="a in getAtividadesPosVenda" :key="a.id">
            <td>{{ a.id }}</td>
            <td>
              {{ a.data_atividade ? $helper.formatDate(a.data_atividade) : "" }}
              {{ a.hora_atividade }}
            </td>
            <td>{{ a.funcionario ? a.funcionario.nome_abreviado : "" }}</td>
            <td>{{ a.descricao }}</td>
            <!-- <td>
              <v-icon v-if="a.concluida" color="success">done</v-icon>
              <v-icon v-else color="error">clear</v-icon>
            </td> -->
            <td>
              <TooltipButton
                @click.native="visualizarAtividadePosVenda(a)"
                classButton="ml-2"
                subtitle="Visualizar"
                icon="search"
                color="primary"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <ModalCadastro />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastro from "@/pages/crm/posVenda/atividade/ModalCadastro";

export default {
  components: {
    ModalCadastro,
  },
  computed: {
    ...mapGetters(["getAtividadesPosVenda", "getPosVenda"]),
  },
  methods: {
    ...mapActions([
      "cadastrarAtividadePosVenda",
      "setModalCadastroAtividadePosVenda",
      "setModalExlcuirAtividadePosVenda",
      "visualizarAtividadePosVenda",
      "listarAtividadesPosVenda",
    ]),
  },
  created() {
    this.listarAtividadesPosVenda(this.getPosVenda);
  },
};
</script>
